import React, { useState } from 'react'
import Lottie from 'lottie-react'

import info from '@/assets/main/main1/main1_board.png'
import phone from '@/assets/main/main1/main1_phone.png'
import MainTopAni from '@/assets/main/main1/mainbanner-animation.json'
import MainTopAni_mo from '@/assets/main/main1/mainbanner-animation-mobile.json'
import useWindowDimensions from '@/shared/hooks/useGetWindowSize'
import { Main1SectionBottom, Main1SectionTop, Main1SectionWrap } from '@/styles/views/Main/main1'

const Main1Section = () => {
  const [fadein, setFadeIn] = useState(false)
  const { width } = useWindowDimensions()

  window.addEventListener('scroll', function () {
    if (window.scrollY > 999 && window.scrollY < 2100) {
      setFadeIn(true)
    } else {
      setFadeIn(false)
    }
  })

  return (
    <Main1SectionWrap>
      <img src={phone} alt="" />
      <Main1SectionTop>
        {width > 1200 ? (
          <>
            <Lottie animationData={MainTopAni} className="lottie" />
            <h3>현실을 넘어선 세상에서 가족을 연결합니다.</h3>
            <img src={info} alt="" />
          </>
        ) : (
          <>
            <h3>
              현실을 넘어선 세상에서 <br />
              가족을 연결합니다.
            </h3>
            <Lottie animationData={MainTopAni_mo} className="lottie" />
          </>
        )}
      </Main1SectionTop>
      <Main1SectionBottom>
        {width > 1200 ? (
          <section>
            <div className="line1">
              <p>#충격알림</p>
              <p>#가족과위치공유</p>
            </div>
            <div className={`line2 ${fadein ? 'active' : 'default'}`}>
              <p>메타버스 라이프로깅</p>
              <p>휴대폰가족보호</p>
            </div>
            <div className="line3">
              <p>#안심장소 등록</p>
              <p>#긴급호출</p>
            </div>
            <div className="line4">
              <p>#미사용감지</p>
              <p>#활동량체크</p>
            </div>
          </section>
        ) : (
          <section>
            <span>#가족과 위치공유</span>
            <span>#안심장소 등록</span>
            <span>#긴급호출</span>
            <span>#활동량체크</span>
            <p>
              메타버스 라이프로깅 서비스 <br />
              휴대폰가족보호
            </p>
          </section>
        )}
      </Main1SectionBottom>
    </Main1SectionWrap>
  )
}
export default Main1Section
